// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sr-trending-timeline-item .sponsored-recommendation--IMAGE,.sr-trending-timeline-item .sponsored-recommendation--VIDEO{padding-inline-start:16px;padding-inline-end:10px}@media(max-width:767px){.sr-trending-timeline-item .sponsored-recommendation--IMAGE,.sr-trending-timeline-item .sponsored-recommendation--VIDEO{padding-inline-start:1px}}", ""]);
// Exports
module.exports = exports;
